import logoImg from '../assets/images/epica_brand_logo_1785606189674.jpg';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showSubtitle?: boolean;
  className?: string;
  textColor?: string;
}

export default function BrandLogo({
  size = 'md',
  showSubtitle = true,
  className = '',
  textColor = 'text-white',
}: BrandLogoProps) {
  const boxDimensions = size === 'sm' ? 'w-10 h-10' : size === 'lg' ? 'w-16 h-16' : 'w-12 h-12';
  const textSize = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-2xl sm:text-3xl' : 'text-xl sm:text-2xl';
  const subtitleSize = size === 'sm' ? 'text-[8px]' : size === 'lg' ? 'text-[11px]' : 'text-[9px] sm:text-[10px]';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${boxDimensions} rounded-xl overflow-hidden shadow-lg shrink-0 flex items-center justify-center bg-slate-950 border border-cyan-500/40 p-0.5 group-hover:border-cyan-400 transition-all`}>
        <img
          src={logoImg}
          alt="ÉPICA Consultora de Comunicaciones Logo"
          className="w-full h-full object-cover rounded-lg"
          referrerPolicy="no-referrer"
        />
      </div>

      <div className="flex flex-col justify-center">
        <span className={`${textSize} font-black tracking-tight leading-none ${textColor}`}>
          ÉPICA
        </span>
        {showSubtitle && (
          <span className={`${subtitleSize} font-bold tracking-widest text-cyan-400 uppercase mt-1 leading-none`}>
            CONSULTORA DE COMUNICACIONES
          </span>
        )}
      </div>
    </div>
  );
}
